import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { AddThreeDotsPipe } from 'src/app/pipes/ellipsis/add-three-dots.pipe';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AdvancedSearchComponent } from 'src/app/components/advanced-search/advanced-search.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LanguageSelectionComponent } from 'src/app/components/language-selection/language-selection.component';
import { DocumentCdaxInteractionsComponent } from 'src/app/components/document-cdax-interactions/document-cdax-interactions.component';
import { FavoriteModalComponent } from 'src/app/components/favorite-modal/favorite-modal.component';
import { FavoritesUserComponent } from 'src/app/components/favorites-user/favorites-user.component';
import { OutsideClickDirective } from '../../directives/outside-click.directive';
import { RedirectURLPipe } from 'src/app/pipes/redirect-url.pipe';
import { ResponseModalComponent } from 'src/app/components/response-modal/response-modal.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FeedbackModalComponent } from 'src/app/components/feedback-modal/feedback-modal.component';
import { ImagePipe } from 'src/app/pipes/image-pipe/safe-image.pipe';
import { HighlightTxtPipe } from 'src/app/pipes/highlight-text.pipe';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        AdvancedSearchComponent,
        LanguageSelectionComponent,
        DocumentCdaxInteractionsComponent,
        FavoriteModalComponent,
        FavoritesUserComponent,
        ImagePipe,
        AddThreeDotsPipe,
        RedirectURLPipe,
        OutsideClickDirective,
        ResponseModalComponent,
        FeedbackModalComponent,
        HighlightTxtPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        DragDropModule,
        NgbModule,
        NgSelectModule,
        ReactiveFormsModule,
        AngularEditorModule,
        NgbTypeaheadModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgbModule,
        HeaderComponent,
        FooterComponent,
        AdvancedSearchComponent,
        LanguageSelectionComponent,
        DocumentCdaxInteractionsComponent,
        FavoritesUserComponent,
        ImagePipe,
        RedirectURLPipe,
        HighlightTxtPipe
    ]
})

export class SharedModule { }
